module.exports = __webpack_public_path__ + "assets/images/1$B.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1$B.png
// module id = 1270
// module chunks = 1